import { useEffect, useState } from 'react';
import DadosExameManager from '../dadosExameManager';

export const useMaterialConservante = (
  exame, 
  material, 
  handleChangeMaterial,
  conservante, 
  handleChangeConservante
) => {
    const [listaMateriais, setListaMateriais] = useState([]);
    const [loadingMaterial, setLoadingMaterial] = useState(true);
    const [listaConservantes, setListaConservantes] = useState([]);
    const [loadingConservante, setLoadingConservante] = useState(true);

    useEffect(() => {
        function handleChangeNovoValor(novoValor) {
          if (material !== novoValor) {
            handleChangeMaterial(novoValor);
          }
        }
    
        const atualizarMaterial = async () => {
          if (!exame) {
            return;
          }
    
          setLoadingMaterial(true);
          const lista = await DadosExameManager.listarMateriais(exame.mnemonico, exame.material);
          const listaMateriaisTratada = lista.materiais ? lista.materiais : [];
          setListaMateriais(listaMateriaisTratada);
          if (material && listaMateriaisTratada.some(m => m.codigo === material)) return;
    
          if (listaMateriaisTratada.length === 1) {
            handleChangeNovoValor(listaMateriaisTratada[0].codigo);
          } else if (listaMateriaisTratada.length === 0) {
            handleChangeNovoValor('');
          } else if (listaMateriaisTratada.length > 0) {
            handleChangeNovoValor('');
            setLoadingConservante(false);
          }
          setLoadingMaterial(false);
        };
    
        atualizarMaterial();
      }, [exame, material, handleChangeMaterial]);

      useEffect(() => {
        function handleChangeNovoValor(novoValor) {
          if (conservante !== novoValor) {
            handleChangeConservante(novoValor);
          }
        }
    
        async function atualizarConservante() {
          setLoadingConservante(true);
          if (exame && material) {
            const lista = await DadosExameManager.listarConservantes(exame.mnemonico, exame.material, material);
            setListaConservantes(lista.conservantes ? lista.conservantes : []);
    
            const conservanteVazio = !conservante || conservante === 'NR';
            if (!conservanteVazio && lista.conservantes.some(m => m.codigo === conservante)) return;
    
            if (lista.conservantes && lista.conservantes.length === 1) {
              handleChangeNovoValor(lista.conservantes[0].codigo);
            } else if (!lista.conservantes || lista.conservantes.length === 0) {
              handleChangeNovoValor('NR');
            } else if (lista.conservantes.length > 0) {
              handleChangeNovoValor('');
            }
            setLoadingConservante(false);
          }
        }
        atualizarConservante();
      }, [handleChangeConservante, conservante, material, exame]);

      const atualizarLoadings = (lMaterial, lConservante) => {
        setLoadingMaterial(lMaterial);
        setLoadingConservante(lConservante);
      }
    
    return {
        listaMateriais: listaMateriais,
        loadingMaterial: loadingMaterial,
        listaConservantes: listaConservantes,
        loadingConservante: loadingConservante,
        atualizarLoadings: atualizarLoadings
    }
}